import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "flex-lg-row-fluid" }
const _hoisted_2 = {
  key: 0,
  class: "card card-one",
  id: "kt_chat_messenger"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_Content = _resolveComponent("Content")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.conversationId)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_Header, {
            onSearchMessage: _ctx.searchMessage,
            selectedData: _ctx.selectedData,
            taskName: _ctx.taskName
          }, null, 8, ["onSearchMessage", "selectedData", "taskName"]),
          _createVNode(_component_Content, { searchTerm: _ctx.searchTerm }, null, 8, ["searchTerm"])
        ]))
      : _createCommentVNode("", true)
  ]))
}